const Style = {
    page: 'flex min-h-0 flex-1 flex-col',
    card: 'w-full',
    embedTitle: 'text-base font-semibold text-text-primary',
    body: 'flex min-h-0 min-w-0 flex-1 flex-col',
    inviteBtn: 'h-9 w-full shrink-0 sm:w-auto',

    identity: 'flex min-w-0 items-center gap-3',
    identityName: 'truncate font-medium text-text-primary',
    inviteMark:
        'flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-muted text-text-muted',
    secondary: 'text-sm text-text-secondary',
    badge: 'ml-0',
    menuTrigger:
        'flex h-8 w-8 items-center justify-center rounded-md text-text-muted transition-colors hover:bg-muted hover:text-text-primary',

    cardRow: 'flex items-start gap-3',
    cardBody: 'min-w-0 flex-1',
    cardEmail: 'truncate text-xs text-text-secondary',
    cardMeta: 'mt-1.5 flex flex-wrap items-center gap-2 text-xs text-text-muted',
};

export default Style;
